const feats = [
  {
    icon: "ri-tv-2-line",
    title: "综艺",
    desc: "节目动态与嘉宾阵容全掌握",
    image:
      "https://readdy.ai/api/search-image?query=variety%20show%20stage%20with%20warm%20spotlight%20and%20colorful%20set%20design%2C%20entertainment%20television%20set%2C%20editorial%20photography%2C%20vibrant%20yet%20warm%20tones&width=480&height=360&seq=cat-tv&orientation=landscape",
  },
  {
    icon: "ri-film-line",
    title: "影视",
    desc: "票房口碑与片单动向追踪",
    image:
      "https://readdy.ai/api/search-image?query=film%20production%20backdrop%20with%20camera%20and%20warm%20studio%20lights%2C%20movie%20set%2C%20editorial%20cinema%20photography%2C%20amber%20tones&width=480&height=360&seq=cat-film&orientation=landscape",
  },
  {
    icon: "ri-mic-line",
    title: "音乐",
    desc: "新歌发布与现场演出资讯",
    image:
      "https://readdy.ai/api/search-image?query=music%20stage%20with%20warm%20lights%20and%20microphone%2C%20live%20concert%20atmosphere%2C%20editorial%20photography%2C%20coral%20and%20amber%20tones&width=480&height=360&seq=cat-music&orientation=landscape",
  },
  {
    icon: "ri-shirt-line",
    title: "时尚",
    desc: "红毯造型与品牌潮流参考",
    image:
      "https://readdy.ai/api/search-image?query=fashion%20editorial%20with%20warm%20backdrop%20and%20elegant%20outfit%20details%2C%20glamour%20photography%2C%20soft%20golden%20lighting&width=480&height=360&seq=cat-fashion&orientation=landscape",
  },
];

export default function CategorySection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-secondary-700 ring-1 ring-background-200">
            <i className="ri-apps-2-line" />
            内容栏目
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">按栏目追踪热点</h2>
          <p className="mx-auto mt-2 max-w-lg text-sm text-foreground-600">
            选择你感兴趣的领域，快速定位对应热点内容与深度专题。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {feats.map((f) => (
            <a
              key={f.title}
              href="/latest"
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-100"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={f.image}
                  alt={`${f.title}栏目热点追踪`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-background-50/90 text-primary-600">
                  <i className={f.icon} />
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{f.title}</h3>
                <p className="mt-1 text-sm text-foreground-600">{f.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  进入栏目 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}